/*
 * Copyright (c) 2023
 * 
 * Created Date: Thursday, July 27th 2023, 8:43:56 pm
 * Author: 🫰Aris Bimas Nugroho
 * 
 */
export const PRIVILEGE_ID = {
    PR: 1010000,//pending task dan pr list
    CreatePR: 1010100,//btn create dan halaman create
    ViewAllPRInOneDepartment: 1010200,// not use
    CancelPRInOneDepartment: 1010202,// not use
    ClosePRInOneDepartment: 1010203,// not use
    ViewAllPRInOneDivision: 1010210,// not use
    CancelPRInOneDivision: 1010212,// not use
    ClosePRInOneDivision: 1010213,// not use
    ViewAllPRInAllDivision: 1010220,// not use
    CancelPRInAllDivision: 1010222,// not use
    ClosePRInAllDivision: 1010223,// not use

    RFQ: 1020000,//pending task dan rfq list
    CreateRFQ: 1020100,//btn create dan halaman create
    ViewAllRFQ: 1020200,
    CancelAllRFQ: 1020202,

    VendorQuotation: 1030000, //vq list
    CreateVendorQuotation: 1030100, //btn create dan halaman create
    ViewAllVendorQuotation: 1030200,
    CencelAllVendorQuotation: 1030201,

    VendorSelection: 1040000, //vs list
    CreateVendorSelection: 1040100, //btn create dan halaman create
    ViewAllVendorSelection: 1040200,
    CencelAllVendorSelection: 1040201,

    PO: 1050000, //vs list
    CreatePO: 1050100, //btn create dan halaman create
    ViewAllPO: 1050200,
    CencelAllPO: 1050201,

    RoGS: 1060000, //rogs list
    CreateRoGS: 1060100, //btn create dan halaman create
    ViewAllRoGS: 1060200,
    CencelAllRoGS: 1060201,

    Invoice: 1070000, //iv list
    CreateInvoice: 1070100, //btn create dan halaman create
    ViewAllInvoice: 1070200,
    CencelAllInvoice: 1070201,

    // cost center
    CostCenter: 2090000, // allow access master menu
    AddEditCostCenter: 2090100, // allow add/edit master data

    // division
    Division: 2070000,
    AddEditDivision: 2070100,

    // Org
    Org: 8180000,
    AddEditOrg: 8181000,

    // ic goods
    ItemCategoryGoods: 2030000,
    AddEditItemCategoryGoods: 2030100,

    // ic services
    ItemCategoryServices: 2040000,
    AddEditItemCategoryServices: 2040100,

    // uom
    UOM: 2050000,
    AddEditUOM: 2050100,

    // department
    Department: 2080000,
    AddEditDepartment: 2080100,


    // position
    Position: 2090000,
    AddEditPosition: 2090100,


    // wbs
    Wbs: 2100000,
    AddEditWbs: 2100100,

    // department cost center
    DepartmentCostCenter: 2100000,
    AddEditDepartmentCostCenter: 2100100,

    // item goods
    ItemGoods: 2010000,
    AddEditItemGoods: 2010100,

    // item service
    ItemService: 2020000,
    AddEditItemService: 2020100,

    // item
    Item: 2010000,
    AddEditItem: 2010100,

    // item catalog
    ItemCatalog: 2060000,
    AddEditItemCatalog: 2060100,

    // role
    Role: 2120000,
    AddEditRole: 2120100,

    // employee
    Employee: 2110000,
    AddEditEmployee: 2110100,

    // employee
    User: 2130000,
    AddEditUser: 2130100,

    // item category
    ItemCategory: 2030000,
    AddEditItemCategory: 2030100,

    // wf role
    WfRole: 2140000,
    AddEditWfRole: 2140100,

    // email template
    EmailTemplate: 2170000,
    AddEditEmailTemplate: 2171000,

    // country
    Country: 2020000,
    AddEditCountry: 2020100,

    // bank
    Bank: 2180000,
    AddEditBank: 2181000,

    // bank account
    BankAccount: 2190000,
    AddEditBankAccount: 2191000,

    // industy type
    IndustryType: 2200000,
    AddEditIndustryType: 2201000,

    // Cost Center Approval Mapping
    CostCenterApprovalMapping: 2210000,
    AddEditCostCenterApprovalMapping: 2211000,

    // vendor
    Vendor: 2160000,
    AddEditVendor: 2160100,

    // md coa
    MDCOA: 2220000,
    MDCOAAddEdit: 2220100,

    //report
    PRbyDivision: 3010000,
    PRTracking: 3020000,
    SLAProcurement: 3030000,
    POByVendor: 3040000,

    //Dashboard
    Dashboard: 1000,
    PendingTask: 1010,
    YourInProgressPR: 1020,
    PRNeedRFQ: 1030,
    POLateDelivery: 1040,
}